<ul
  ngbNav
  #tabs="ngbNav"
  [(activeId)]="activeTabId"
  (navChange)="onSearchMapTabChange($event)"
  [destroyOnHide]="true"
  class="nav-tabs"
  [class.permit-blue-tabs]="templateForPermitForm"
>
 <li [ngbNavItem]="'searchTab'" id="searchTab">
  <a ngbNavLink class="active-tab">Search</a>

  <ng-template ngbNavContent>
    <form
      [formGroup]="form"
      style="max-width:600px"
      *ngIf="searchParcelDataCriteria"
    >

      @if (!templateForPermitForm) {
  <div class="form-group">
          <label for="parcelIdSearch" class="bmd-label-static">
            Parcel ID:
          </label>
          <div class="row">
            <div class="col-10">
              <input
                id="parcelIdSearch"
                type="text"
                class="form-control"
                [formControl]="searchParcelIdCtl"
                [(ngModel)]="searchParcelDataCriteria.searchParcelId"
              />
            </div>
            <div class="col-2">
              <button
                class="btn btn-primary btn-raised"
                [disabled]="!searchParcelDataCriteria.searchParcelId"
                (click)="searchByParcelId()"
              >
                Search
              </button>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="parcelOwnerSearch" class="bmd-label-static">
            Property Owner:
          </label>
          <div class="row">
            <div class="col-10">
              <input
                id="parcelOwnerSearch"
                type="text"
                class="form-control"
                [formControl]="searchParcelOwnerNameCtl"
                [(ngModel)]="searchParcelDataCriteria.searchParcelOwnerName"
              />
            </div>
            <div class="col-2">
              <button
                class="btn btn-primary btn-raised"
                [disabled]="!searchParcelDataCriteria.searchParcelOwnerName"
                (click)="searchByOwnerName()"
              >
                Search
              </button>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="propertyAddressSearch" class="bmd-label-static">
            Property Address:
          </label>
          <div class="row">
            <div class="col-10">
              <input
                id="propertyAddressSearch"
                type="text"
                class="form-control"
                [formControl]="searchParcelAddressCtl"
                [(ngModel)]="searchParcelDataCriteria.searchParcelAddress"
              />
            </div>
            <div class="col-2">
              <button
                class="btn btn-primary btn-raised"
                [disabled]="!searchParcelDataCriteria.searchParcelAddress"
                (click)="searchByAddress()"
              >
                Search
              </button>
            </div>
          </div>
        </div>
        <div class="form-group">
          <ng-container *ngIf="
            (
              searchParcelDataCriteria.searchParcelId
              && searchParcelDataCriteria.searchParcelOwnerName
            )
            ||
            (
              searchParcelDataCriteria.searchParcelOwnerName
              && searchParcelDataCriteria.searchParcelAddress
            )
            ||
            (
              searchParcelDataCriteria.searchParcelId
              && searchParcelDataCriteria.searchParcelAddress
            )"
          >
            <button
              class="btn btn-primary btn-raised"
              (click)="submitSearchParcelDataCriteria()"
            >
              Search All
            </button>
          </ng-container>

          <span
            class="text-danger pl-1"
            *ngIf="
              !form.controls['ParcelGeometry'].valid &&
              form.controls['ParcelGeometry'].touched
            "
          >
            Getting Parcel Geometry
          </span>
        </div>


      }


      @else {

        <div class="row mt-2" *ngIf="activity.model.isRequired && !activity.model.selectedParcel && form.controls['ParcelId']?.touched">
          <div class="col-12 font-weight-bold" style="color: red;">
            Select parcel search to proceed.
          </div>
        </div>

        <div class="row  mt-4">
          <div class="col-12 col-md-8 col-lg-10 mb-2 mb-md-0">
            <wm-common-textfield
              [data]="{
                label: 'Parcel ID',
                id: 'parcelIdSearch'

              }"
              [formControl]="searchParcelIdCtl"
                [(ngModel)]="searchParcelDataCriteria.searchParcelId"
              >

            </wm-common-textfield>
          </div>

          <div class="col-12 col-md-4 col-lg-2">
            <wm-common-button class="btn-search"
              [data]="{
                text: 'Search',
                
                
                disabled: !searchParcelDataCriteria.searchParcelId,
                onClick: searchByParcelId.bind(this)
              }">
            </wm-common-button>
          </div>
        </div>


        <div class="row mt-3">
          <div class="col-12 col-md-8 col-lg-10 mb-2 mb-md-0">
            <wm-common-textfield
              [data]="{
                label: 'Property Owner',
                id: 'parcelOwnerSearch'
              }"
               [formControl]="searchParcelOwnerNameCtl"
                [(ngModel)]="searchParcelDataCriteria.searchParcelOwnerName"
              >
            </wm-common-textfield>
          </div>

          <div class="col-12 col-md-4 col-lg-2">
            <wm-common-button class="btn-search"
              [data]="{
                text: 'Search',
                
                
                disabled: !searchParcelDataCriteria.searchParcelOwnerName,
                onClick: searchByOwnerName.bind(this)
              }">
            </wm-common-button>
          </div>
        </div>


        <div class="row mt-3">
          <div class="col-12 col-md-8 col-lg-10 mb-2 mb-md-0">
            <wm-common-textfield
              [data]="{
                label: 'Property Address',
                id: 'propertyAddressSearch'
              }"
               [formControl]="searchParcelAddressCtl"
                [(ngModel)]="searchParcelDataCriteria.searchParcelAddress"
              >
            </wm-common-textfield>
          </div>

          <div class="col-12 col-md-4 col-lg-2">
            <wm-common-button class="btn-search"
              [data]="{
                text: 'Search',
                
                
                disabled: !searchParcelDataCriteria.searchParcelAddress,
                onClick: searchByAddress.bind(this)
              }">
            </wm-common-button>
          </div>
        </div>

        <div class="row mt-3" style="margin-left: 0px !important;">
          <ng-container *ngIf="
            (
              searchParcelDataCriteria?.searchParcelId
              && searchParcelDataCriteria?.searchParcelOwnerName
            )
            ||
            (
              searchParcelDataCriteria?.searchParcelOwnerName
              && searchParcelDataCriteria?.searchParcelAddress
            )
            ||
            (
              searchParcelDataCriteria?.searchParcelId
              && searchParcelDataCriteria?.searchParcelAddress
            )"
          >

             <wm-common-button class="btn-search"
              [data]="{
                text: 'Search All',
                
                
                onClick: submitSearchParcelDataCriteria.bind(this)
              }">
            </wm-common-button>
          </ng-container>

          <span
            class="text-danger pl-1"
            *ngIf="
              !form.controls['ParcelGeometry'].valid &&
              form.controls['ParcelGeometry'].touched
            "
          >
            Getting Parcel Geometry
          </span>
          </div>
      }

    </form>
  </ng-template>
</li>

  <li ngbNavItem="mapTab" id="mapTab" [disabled]="!activity.model.hasMap">
    <a ngbNavLink>Map</a>
    <ng-template ngbNavContent>
      <div class="tab-pane fade active show" id="mapTab">
        <app-esri-map
          #esriMap
          [mapServiceId]="activity.model.mapConfig.mapServiceId"
          [basemapName]="activity.model.mapConfig.basemapName"
          [initialExtent]="activity.model.mapConfig.initialExtent"
          [mapLayerOptions]="activity.model.mapConfig.layers"
          [showToc]="activity.model.mapConfig.showToc"
          (featuresIdentified)="onParcelsIdentified($event)"
          (featuresBeforeIdentifying)="onParcelsBeforeIdentifying()"
          (mapLoaded)="onMapLoaded()"
          useSketchLayer="false"
        ></app-esri-map>
      </div>
    </ng-template>
  </li>
  <li ngbNavItem="mayParcels" id="mayParcels" [disabled]="!userId">
    <a ngbNavLink>My Parcels</a>
    <ng-template ngbNavContent>
      <div style="border-bottom: 1px solid gray">
           @if(!templateForPermitForm){
        <wm-my-application-parcels
          [userId]="userId"
          (parcelSelected)="myParcelSelected($event)"
        ></wm-my-application-parcels>
           }
           @else{
             <wm-my-application-parcels
          [userId]="userId"
          [janus]="true"
          (parcelSelected)="myParcelSelected($event)"></wm-my-application-parcels>
          <br />
           }
      </div>
    </ng-template>
  </li>
</ul>
<div [ngbNavOutlet]="tabs"></div>

<app-loader *ngIf="loading"></app-loader>

<div
  *ngIf="!loading && resultsText"
  [innerHtml]="resultsText">
</div>




    @if(!templateForPermitForm){
<table class="table" *ngIf="results && results.length > 0">
  <thead>
    <tr>
      <th scope="col"></th>
      <th scope="col">Parcel ID</th>
      <th scope="col">Address</th>
      <th scope="col">City</th>
      <th scope="col">Owner Name</th>
      <th scope="col" class="align-right">Acres</th>
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let r of results">
      <tr
        *ngIf="showParcel(r)"
        [ngClass]="{ 'table-active': isParcelSelected(r) }"
      >
        <td>
          <div class="custom-control custom-radio" *ngIf="!hideResultsOnSelect">
            <input
              type="radio"
              class="custom-control-input"
              [(ngModel)]="activity.model.selectedParcel"
              [value]="r"
              name="search"
              [id]="r.parcelID"
              (change)="selectOneResult(r, true)"
            />
            <label class="custom-control-label" [for]="r.parcelID"></label>
          </div>

          <a
            *ngIf="hideResultsOnSelect"
            href="javascript:void(0)"
            (click)="selectOneResult(r, true, true)"
          >
            <span *ngIf="isParcelSelected(r)">Selected</span>
            <span *ngIf="!isParcelSelected(r)">Select</span>
          </a>
        </td>
        <td>{{ r.parcelID }}</td>
        <td>{{ r.address }}</td>
        <td>{{ r.city }}</td>
        <td>{{ r.ownerName }}</td>
        <td class="align-right">
          {{ r.acres * 1 | number: '1.3-3' }}
        </td>

        <td class="align-right">
          <button
            type="button"
            class="btn btn-raised btn-primary float-right notes-button"
            (click)="parcelNotesModal.open()"
            *ngIf="
              !(
                (r.internalNote == '0' &&
                  r.publicNote == '0' &&
                  !canManageParcelNotes == true) ||
                (r.publicNote == '0' && !canViewInternalParcelNotes == true)
              )
            "
          >
            <!--
           *ngIf ="!(((r.internalNote=='0' && r.publicNote=='0') && !canManageParcelNotes==true)||((r.publicNote=='0') && !canViewInternalParcelNotes==true))"
        Currently No Notes on the parcel, but I can add some.
        Currently Either internal or public Notes on the parcel that can be edited
        Currently Either internal or public Notes on the parcel that can't be edited
        Currently There are either No Notes on the parcel OR no public notes and you don't have permission to view the internal notes.  --there is no visible button in this case because it won't pass the inIf for the button element.
      -->
            <span
              *ngIf="
                r.internalNote == '0' &&
                r.publicNote == '0' &&
                canManageParcelNotes == true
              "
              >Add Note</span
            >
            <span
              *ngIf="
                !(r.internalNote == '0' && r.publicNote == '0') &&
                canManageParcelNotes == true
              "
              >Modify Note</span
            >
            <span
              *ngIf="
                !(r.internalNote == '0' && r.publicNote == '0') &&
                !canManageParcelNotes == true
              "
              >View Note</span
            >
            <!-- this should stay hidden -->
            <span
              *ngIf="
                (r.internalNote == '0' &&
                  r.publicNote == '0' &&
                  !canManageParcelNotes == true) ||
                (r.publicNote == '0' && !canViewInternalParcelNotes == true)
              "
              >No Note</span
            >
          </button>
        </td>

        <wm-modal-confirm
          title="Parcel Notes"
          [small]="false"
          [showButtonText]="false"
          [showButton]="false"
          commandText="Save"
          (accepted)="notesModal(publicNote, internalNote, r.parcelID)"
          (opened)="getParcelNote(r.parcelID)"
          [showCommandButton]="canManageParcelNotes"
          #parcelNotesModal
        >
          <label id="lblParcelID"
            ><strong>{{ r.parcelID }}</strong></label
          ><br />
          <label id="lblPublicNote">Public Note</label>
          <textarea
            class="form-control"
            name="publicNote"
            id="publicNote"
            rows="20"
            aria-describedby="lblPublicNote"
            [(ngModel)]="publicNote"
            [readonly]="!canManageParcelNotes"
          >
          </textarea>
          <!-- TODO: Make sure I check permissions server side, so I don't even return value if I don't have permissions.  -->
          <!-- <br /> -->
          <label
            id="lblInternalNote"
            *ngIf="canViewInternalParcelNotes == true"
          >
            Internal Note
          </label>
          <textarea
            class="form-control"
            name="InternalNote"
            id="InternalNote"
            rows="20"
            aria-describedby="lblInternalNote"
            [(ngModel)]="internalNote"
            *ngIf="canViewInternalParcelNotes == true"
            [readonly]="!canManageParcelNotes"
          >
          </textarea>
        </wm-modal-confirm>
      </tr>
    </ng-container>
  </tbody>
</table>
    }
    @else{
      <br />
       <wm-common-table
          *ngIf="results && results.length > 0"
          [columns]="parcelTableColumns"
          [data]="trimmedResults"
          tableClass="table"
          (rowClick)="onParcelRowClick($event)"
          (radioSelect)="onParcelRowClick($event)">
        </wm-common-table>

<wm-modal-confirm
  title="Parcel Notes"
  [small]="false"
  [showButtonText]="false"
  [showButton]="false"
  commandText="Save"
  (accepted)="notesModal(publicNote, internalNote, selectedParcelForNotes?.parcelID)"
  (opened)="getParcelNote(selectedParcelForNotes?.parcelID)"
  [showCommandButton]="canManageParcelNotes"
  [janusStyling]="true" janusModalWidth="640px"
  #ParcelNotesModal
>

  <div class="mb-3">
    <strong>{{ selectedParcelForNotes?.parcelID }}</strong>
  </div>

  <wm-common-textfield
    [data]="{
      label: 'Public Note',
      textAreaRows: 8,
      type: 'text-area',
      readonly: !canManageParcelNotes,
    }"
    [(ngModel)]="publicNote"
    >
  </wm-common-textfield>

  <wm-common-textfield
    *ngIf="canViewInternalParcelNotes"
    [data]="{
      label: 'Internal Note',
      textAreaRows: 8,
      type: 'text-area',
      readonly: !canManageParcelNotes
    }"
    [(ngModel)]="internalNote"
    >
  </wm-common-textfield>

</wm-modal-confirm>

    }


<p *ngIf="!loading && results && results.length < 1">No results</p>